import { ReactElement, useState, useEffect } from 'react';
import { Column, Row, Modal } from 'carbon-components-react';
import '../style/common.scss';
import '../style/responseModal.scss';
import { segmentsTracking } from '../lib/tracker';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';

export interface thanksTable {
  group: string;
  value: string;
}

export interface FormModalProperties {
  pageTitle: string;
  object: string;
  productTitle: string;
  pageUrl: string;
  location: string;
  bpName: string;
  logo: string;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
}

export const FormModal = ({
  pageTitle,
  object,
  productTitle,
  pageUrl,
  location,
  bpName,
  logo,
  drawerOpen,
  setDrawerOpen,
  id,
}: FormModalProperties): ReactElement => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(drawerOpen);
  }, [drawerOpen]);

  return (
    <div className="ResponseModal">
      <Row>
        <Column sm={4} md={16} lg={16}>
          <Modal
            passiveModal={true}
            open={showModal}
            size={'lg'}
            onRequestClose={() => {
              segmentsTracking('CTA Clicked', {
                productTitle,
                pageTitle,
                object,
                pageUrl,
                resultValue: 'CTA clicked',
                CTA: 'Form modal closed on the corner',
                location,
                action: `Form modal closed`,
                field: '',
              });
              setShowModal(false);
              setDrawerOpen(false);
            }}
            onRequestSubmit={() => {
              segmentsTracking('CTA Clicked', {
                productTitle,
                pageTitle,
                object,
                pageUrl,
                resultValue: 'CTA clicked',
                CTA: 'Form submitted',
                location,
                action: `Form modal closed`,
                field: '',
              });
              setShowModal(false);
              setDrawerOpen(false);
              window.location.reload();
            }}
          >
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                {bpName ? (
                  <BusinessPartner bpName={bpName} logo={logo} urxForm={true} />
                ) : null}
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                <div id="urx-form-container">
                  {/* Solution for having two urx form on same page */}
                  <div no-toc id={`${id ? id : 'urx-form'}`}></div>
                </div>
              </div>
            </div>
          </Modal>
        </Column>
      </Row>
    </div>
  );
};
